// extracted by mini-css-extract-plugin
export default {"button":"Button_button__jpY3J","light":"Button_light__LlCTL"};